<div class="table-responsive no-print">
    <table mat-table [dataSource]="dataSource" matSort class="full-width-table">

        <ng-container matColumnDef="{{column.attributeName}}" *ngFor="let column of columns">
            <th mat-header-cell *matHeaderCellDef>
                {{ column.displayName }}
            </th>
            <td mat-cell *matCellDef="let element">
                <span *ngIf="column.type === 'date'">
                    {{ element[column.attributeName] | date: 'dd/MM/yyyy' }}
                </span>
                <span *ngIf="column.type === 'datetime'">
                    {{ element[column.attributeName] | date: 'dd/MM/yyyy HH:mm' }}
                </span>
                <span *ngIf="column.type === 'currency'">
                    ${{ element[column.attributeName] | number: '1.0-0' }}
                </span>
                <span *ngIf="column.type === 'text' || !column.type">
                    {{ element[column.attributeName] }}
                </span>
            </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>
                Acciones
            </th>
            
            <td mat-cell *matCellDef="let element" class="td-actions">
                
                <div class="d-flex actions-container">
                    <button mat-mini-fab
                        *ngIf="showEditButton"
                        class="tertiary-color shadow-none no-print" 
                        aria-label="Editar"
                        (click)="onEdit(element)">
                        <mat-icon>edit</mat-icon>
                    </button>

                    <button mat-mini-fab
                        *ngIf="showDeleteButton"
                        class="error-color shadow-none no-print" 
                        aria-label="Eliminar"
                        (click)="onDelete(element)">
                        <mat-icon>delete</mat-icon>
                    </button>

                    <button mat-icon-button
                        *ngIf="showConfigButton"
                        class="shadow-none no-print" 
                        aria-label="Configurar"
                        (click)="onConfig(element)">
                        <mat-icon fontSet="material-symbols-outlined">settings</mat-icon>
                    </button>
                    
                    <button class="custom-button-secondary" 
                        mat-flat-button  
                        *ngIf="customAction"
                        (click)="onExecuteCustomAction(element)" >
                        {{  customAction }}
                    </button>
                </div>

            </td>
        </ng-container>
    
        <ng-container matColumnDef="progress">
            <th mat-cell *matCellDef="let element"></th>
            <td mat-header-cell *matHeaderCellDef [attr.colspan]="displayedColumns.length">
                <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
            </td>
        </ng-container>

        <tr class="mat-mdc-row" *matNoDataRow>
            <td class="mat-mdc-cell text-center font-weight-500" [attr.colspan]="displayedColumns.length">
                {{ isLoading ? 'Cargando...' : 'No hay datos disponibles' }}
            </td>
        </tr>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-header-row *matHeaderRowDef="['progress']; sticky: true" class="progress-row"></tr>
        <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns;"
            [class.cursor-pointer]="row.detail ? true : false"
            (click)="row.detail && onRowClicked(row)">
        </tr>
    </table>
</div>

<mat-paginator
    [pageSizeOptions]="[5, 10, 25, 100]"
    showFirstLastButtons
    aria-label="Seleccionar página"
    class="no-print">
</mat-paginator>

<!-- print only table -->
<div class="print-only mt-4">
    <table mat-table [dataSource]="dataSource.data" class="custom-print-table full-width-table">

        <ng-container matColumnDef="{{column.attributeName}}" *ngFor="let column of columns">
            <th mat-header-cell *matHeaderCellDef>
                {{ column.displayName }}
            </th>
            <td mat-cell *matCellDef="let element">
                <span *ngIf="column.type === 'date'">
                    {{ element[column.attributeName] | date: 'dd/MM/yyyy' }}
                </span>
                <span *ngIf="column.type === 'datetime'">
                    {{ element[column.attributeName] | date: 'dd/MM/yyyy HH:mm' }}
                </span>
                <span *ngIf="column.type === 'currency'">
                    ${{ element[column.attributeName] | number: '1.0-0' }}
                </span>
                <span *ngIf="column.type === 'text' || !column.type">
                    {{ element[column.attributeName] }}
                </span>
            </td>
        </ng-container>

        <tr class="mat-mdc-row" *matNoDataRow>
            <td class="mat-mdc-cell text-center font-weight-500" [attr.colspan]="printDisplayedColumns.length">
                No hay datos disponibles
            </td>
        </tr>

        <tr mat-header-row *matHeaderRowDef="printDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: printDisplayedColumns;"></tr>
    </table>
</div>
